<template>
  <div class="mtyas-toast" v-show="isShowDelay">
    <transition name="slide-fade">
      <div class="mtyas-toast-main" v-if="isShow">
        <div class="mtyas-toast-body">
          <div class="alertTypeModalHeader" :class="type">
            <span></span>
          </div>
          <div class="mtyas-toast-msg" v-text="msg">
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: "修改成功",
      time: 2000, //延时
      isShow: false,
      type: '', //type :  success:成功   error:失败  info:提示   warning:警告
      big: false,
      isShowDelay: false,
    }
  },
  methods: {
    hide() {
      // this.isShow = true;
      setTimeout(() => {
        this.isShow = false;
      }, this.time);
    }
  },
  watch: {
    isShow(newval) {
      if (newval) {
        this.isShowDelay = this.isShow;
      } else {
        setTimeout(() => {
          this.isShowDelay = this.isShow;
        }, 400);
      }
    }
  }
}

</script>
<style scoped lang="less">
.alertTypeModalHeader {
  position: absolute;
  width: 108px;
  height: 108px;
  border-radius: 50%;
  border: 9px solid white;
  top: 0px;
  left: 50%;
  color: white;
  font-size: 40px;
  line-height: 87px;
  text-align: center;
  font-weight: bold;
  transform: translate(-50%, -55px);
}

.mtyas-toast {
  z-index: 999999;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .5);
}

.mtyas-toast-main {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.mtyas-toast-body {
  z-index: 999999;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 334px;
  min-height: 230px;
  background-color: #fff;
  padding: 0px 30px;
  text-align: center;
  border-radius: 2px;

  .warning {
    background-color: #ffbe5c;
  }

  .warning span:before {
    content: "!"
  }

  .error {
    background-color: #f76280;
  }

  .error span:before {
    font-family: "iconfont";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\2715"
  }

  .success {
    background-color: #a7d265;
  }

  .success span:before {
    font-family: "iconfont";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: '\2713';
  }

  .info {
    background-color: #ffbe5c;
  }

  .info span:before {
    content: '!';
  }

  .mtyas-toast-header {
    height: 60px;
    border-bottom: 1px dashed #D8D8D8;
    line-height: 60px;
    text-align: left;

    span {
      font-size: 18px;
      color: #3E3E3E;
    }
  }

  .mtyas-toast-msg {
    font-size: 18px;
    position: relative;
    color: #fff;
    width: 100%;
    height: 100%;
    margin-top: 105px;
    color: #585858;
  }

  &.success,
  &.error,
  &.info {
    width: 506px;
    height: 312px;
    background: #FFFFFF;
    border: 0 solid #D5D5D5;
    // box-shadow: 0 1px 8px 0 #E4E4E4;
    // border-radius: 10px;
    box-sizing: border-box;

    .mtyas-toast-msg {
      font-size: 18px;
      color: #4A4A4A;
      width: auto;
      height: auto;
    }

    .iconfont {
      font-size: 60px;
      margin-top: 57px;
      margin-bottom: 20px;
      display: inline-block;
      position: relative;
    }
  }

  &.success {
    .iconfont {
      background-color: #A7D265;
      border-radius: 50%;
    }
  }

  &.error {
    .iconfont {
      background-color: #F27070;
      border-radius: 50%;
    }
  }

  &.info {
    .iconfont {
      background-color: #FFBE5C;
      border-radius: 50%;
    }
  }
}

</style>
